module.exports = __webpack_public_path__ + "media/scenario_end.997aa8d6.mp3";